import { useState, useCallback } from 'react';

/**
 * 生徒選択の状態管理カスタムフック
 * @param {Object} currentUser - 現在のユーザー情報
 * @returns {Object} 生徒選択の状態と操作関数
 */
export const useStudentSelection = (currentUser) => {
  const [selectedStudent, setSelectedStudent] = useState(null);

  /**
   * 現在の生徒IDを取得
   * 教師の場合は選択中の生徒、生徒の場合は自分自身のIDを返す
   */
  const getStudentId = useCallback(() => {
    if (selectedStudent) {
      return selectedStudent.id;
    } else if (currentUser && currentUser.role === 'student') {
      return currentUser.id;
    }
    return null;
  }, [selectedStudent, currentUser]);

  /**
   * 生徒選択をリセット
   */
  const resetStudentSelection = useCallback(() => {
    setSelectedStudent(null);
  }, []);

  /**
   * 指定された生徒が現在選択されているかチェック
   * @param {string} studentId - チェックする生徒ID
   * @returns {boolean} 選択されているかどうか
   */
  const isStudentSelected = useCallback((studentId) => {
    return selectedStudent?.id === studentId;
  }, [selectedStudent]);

  return {
    selectedStudent,
    setSelectedStudent,
    getStudentId,
    resetStudentSelection,
    isStudentSelected
  };
}; 